import React, { useEffect, useState  } from "react";
import API from '../Utils/Api';

const Header = ({ tabHeaderName }) => {
  const [activeItem, setActiveItem] = useState({ name: "", image: "" });

  const [inputs,setInputs] = useState({first_name:'',middel_name:'',last_name:'',profile:''});

  useEffect(() => { 
    document.title = `Header | bluefaucet`;
    document.getElementById("bodywrap").className = "Header";

    /* Start get profile */
  let formData1 = new FormData(); 
    formData1.append('token', localStorage.getItem("token"));
    API.post('backoffice_get_user_detail', formData1)
      .then(response => {
      if(response.data.status ===1){
        setInputs({
            first_name:response.data.data.first_name,
            middel_name:response.data.data.middel_name,
            last_name:response.data.data.last_name,
            profile:response.data.data.profile
        });
      }                
    }).catch(error => {
       
    });  
   /* End get profile */

    const storedItem = localStorage.getItem("activeItem");
    if (storedItem) {
      setActiveItem(JSON.parse(storedItem));
    }
  }, []); 

  return (
    <>
      <div className="row d-none d-md-block">
        <div className="col-md-12 p-0">
          <div className="header d-flex align-items-center justify-content-between">
            <div className="he-name d-flex align-items-center gap-2">
              {activeItem.image && (
                <img
                  src={process.env.REACT_APP_BASE_URL + activeItem.image}
                  alt={activeItem.name}
                />
              )}
              <span>{tabHeaderName || activeItem.headerName || activeItem.name || "Welcome Joan Smith"}</span>
            </div>
            <div className="user-info">
              {/*<div className="flex-grow-1 mx-3">
                <div className="input-group">
                  <div className="input-group-text border-end-0">
                    <img
                      src={process.env.REACT_APP_BASE_URL + 'assests/images/search.png'}
                      alt="Search Icon"
                      className="img-fluid"
                    />
                  </div>
                  <input
                    type="text"
                    className="form-control border-start-0"
                    placeholder="Search"
                  />
                </div>
              </div>*/}
              <div className="noti me-2">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/ghantadi.png'}
                    alt="ghantadi"
                    className="img-fluid"
                  />
                </div>
              <img src={inputs.profile} alt="User Avatar" />
              <span>{inputs.first_name} {inputs.last_name}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;